import { AttributeFieldType } from 'api/attributes/requests';

export const isSelectFieldType = (
  type: AttributeFieldType
): type is 'single_select' | 'multi_select' => {
  return type === 'single_select' || type === 'multi_select';
};
